export const ORDER_AFFILIATE_ORDER = 'order'
export const ORDER_AFFILIATE_EMITTEN = 'emitten'
export const ORDER_AFFILIATE_PRICE = 'price'
export const ORDER_AfFILIATE_AFFILIATE_ID = 'affiliate-id'

export const ORDER_AFFILIATE_ORDER_BUY = 'buy'
export const ORDER_AFFILIATE_ORDER_SELL = 'sell'

export const ORDER_AFFILIATE_PARAMETERS = [ORDER_AFFILIATE_ORDER, ORDER_AFFILIATE_EMITTEN, ORDER_AFFILIATE_PRICE, ORDER_AfFILIATE_AFFILIATE_ID]
export const ORDER_AFFILIATE_REFERER_LINK_BUY = 'https://ajaib.onelink.me/0c71'
export const ORDER_AFFILIATE_REFERER_LINK_SELL = 'https://ajaib.onelink.me/wL6z'